// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TagRowProps {
  game: any;
  style: React.CSSProperties;
  tagsAsFreeText: boolean;
  requesterTags: any[];
  changeTag: (value: string, game: any) => void;
  gameTagOnBlur: (game: any) => void;
}

function TagRow({
  game,
  style,
  tagsAsFreeText,
  requesterTags,
  changeTag,
  gameTagOnBlur,
}: TagRowProps) {
  const { t } = useTranslation();
  return (
    <div className="grid-empty hidden-input" style={style}>
      {tagsAsFreeText ? (
        <input
          type="text"
          className={`form-control ${!game.isSKU ? 'apply' : ''}`}
          value={game.tag || ''}
          placeholder={!game.isSKU ? t('Apply to skus') : ''}
          onChange={(e) => changeTag(e.target.value, game)}
          onBlur={() => {
            if (!game.isSKU) {
              gameTagOnBlur(game);
            }
          }}
        ></input>
      ) : (
        <select
          className={`form-control ${!game.isSKU ? 'apply' : ''}`}
          onChange={(e) => {
            changeTag(e.target.value, game);
          }}
          value={game.tag || ''}
          disabled={game.showRemove}
        >
          {!game.isSKU ? (
            <option value="">{t('Apply to skus')}</option>
          ) : (
            <option value=""></option>
          )}
          {requesterTags &&
            [...requesterTags]
              ?.sort((a: any, b: any) => a.tag.localeCompare(b.tag))
              ?.map((x: any) => (
                <option key={x.id} value={x.id}>
                  {x.tag}
                </option>
              ))}
        </select>
      )}
    </div>
  );
}

export default TagRow;
